








import 'destyle.css'
import { Component, Vue, Prop } from 'vue-property-decorator'
import NavigationBar from '@/components/NavigationBar.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import store from '@/store'

@Component({
  components: {
    NavigationBar,
    ErrorPage
  }
})

export default class App extends Vue {
  @Prop({ default: false }) readonly disabled!: boolean;

  get errorMessage () {
    return store.state.errorMessage
  }

  get routerKey () {
    const route = this.$route
    return route.params.workspaceId
  }
}
